import { sliderConfig } from "../../config/slider.config"
import { capitalizeString } from "../../utils/global.util"
import Slider from "react-slick"
import LiveTVCard from "../Cards/LiveTVCard"

const LiveTVCarousel = ({ maxLines = 2, showTitles = false, channel, items = [], title }) => {
    if (items.length < 1 || !title) return (<></>)
    return (
        <>
            <div className="max-w-[1900px] px-5 py-[30px] pb-[10px] m-auto">
                <h2 className="text-[#fff] text-xl font-medium">{capitalizeString(title)}</h2>
                <div className="-ml-2">
                    <Slider {...sliderConfig(7)}>
                        {
                            items ? channel.channels.map((vod, i) => {

                                const _vod = { ...vod }
                                const _epg = items.filter(epg => {
                                    return vod.id === epg.id
                                })

                                if (_epg.length > 0) _vod.shows = _epg[0].shows

                                return (
                                    <LiveTVCard
                                        key={i + _vod.id}
                                        content={_vod}
                                        showTitles={showTitles}
                                        maxLines={maxLines}
                                    />
                                )
                            }) : <></>
                        }
                    </Slider>
                </div>
            </div>
        </>
    )
}

export default LiveTVCarousel